import APIRequest from '../api/APIRequest';

export const staffService = {
  // Get all teachers
  getAllTeachers: async (token) => {
    try {
      const api = new APIRequest();
      const response = await api.request('/admin/getAllTeachers', 'GET', {}, token);
      if (response.success) {
        return response.teachers;
      } else {
        return [];
      }
    } catch (error) {
      console.error('Error fetching teachers:', error);
      return [];
    }
  },

  // Get teacher by ID
  getTeacherById: async (id, token) => {
    try {
      const api = new APIRequest();
      const response = await api.request(`/admin/getTeacher?id=${id}`, 'GET', {}, token);
      if (response.success) {
        return response.teacher;
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error fetching teacher:', error);
      return null;
    }
  },

  // Add new teacher
  addTeacher: async (teacherData, token) => {
    try {
      const api = new APIRequest();
      const response = await api.request('/admin/createTeacher', 'POST', teacherData, token);
      return response;
    } catch (error) {
      console.error('Error creating teacher:', error);
      return { success: false, message: 'Failed to create teacher' };
    }
  },

  // Update teacher
  updateTeacher: async (id, teacherData, token) => {
    try {
      const api = new APIRequest();
      const response = await api.request(`/admin/updateTeacher?id=${id}`, 'POST', teacherData, token);
      return response;
    } catch (error) {
      console.error('Error updating teacher:', error);
      return { success: false, message: 'Failed to update teacher' };
    }
  },

  // Delete teacher
  deleteTeacher: async (id, token) => {
    try {
      const api = new APIRequest();
      const response = await api.request(`/admin/deleteTeacher?id=${id}`, 'DELETE', {}, token);
      return response;
    } catch (error) {
      console.error('Error deleting teacher:', error);
      return { success: false, message: 'Failed to delete teacher' };
    }
  }
};
